angular.module('unica_invitation_list.invitation_list_controllers')

.controller('InvitationListComunicateController', function( $scope, $rootScope, $stateParams ) {

	$rootScope.getInvitationList($stateParams.id);

	$scope.id = $stateParams.id;
	$scope.event_id = $stateParams.event_id;

	$scope.forms = {};
});
